<template>
  <ClientOnly fallback-tag="span">
    <Chip
      size="small"
      :color="isOpen ? 'green' : 'red'">
      {{ getStatus() }}
    </Chip>
    <template #fallback>
      <Chip
        size="small">
        {{ $t('stores/loading') }}
      </Chip>
    </template>
  </ClientOnly>
</template>
<script setup>
import { parseISO, isFuture, isPast } from 'date-fns'

const { $t, $formatDate } = useNuxtApp()
const props = defineProps({
  openingHours: {
    type: Array,
    default: () => []
  },
  specialOpensAt: {
    type: String,
    default: () => null
  },
  storeName: {
    type: String,
    default: () => ''
  }
})
await useI18n(['stores'])

const isOpen = computed(() => {
  if (!props.openingHours[0]?.opensAt || !props.openingHours[0]?.closesAt) { return false }
  return isPast(parseISO(props.openingHours[0].opensAt)) && isFuture(parseISO(props.openingHours[0].closesAt)) ? props.openingHours[0].closesAt : null
})
const opensToday = computed(() => {
  if (!props.openingHours[0]?.opensAt || !props.openingHours[0]?.closesAt) { return false }
  return isFuture(parseISO(props.openingHours[0].opensAt)) && isFuture(parseISO(props.openingHours[0].closesAt)) ? props.openingHours[0].opensAt : null
})
const opensTomorrow = computed(() => {
  if (!props.openingHours[1]?.opensAt || !props.openingHours[1]?.closesAt) { return false }
  return isFuture(parseISO(props.openingHours[1].opensAt)) && isFuture(parseISO(props.openingHours[1].closesAt)) ? props.openingHours[1].opensAt : null
})
const opensLater = computed(() => {
  for (let index = 2; index < props.openingHours.length; index++) {
    const el = props.openingHours[index]
    if (isFuture(parseISO(el.opensAt)) && isFuture(parseISO(el.closesAt))) {
      return el.opensAt
    }
  }
})

const getStatus = () => {
  if (props.specialOpensAt && isFuture(parseISO(props.specialOpensAt))) {
    return $t('stores/opens-later-at') + ' ' + $formatDate(props.specialOpensAt, 'dd mm hh:mm', 'Europe/Amsterdam')
  }
  if (isOpen.value) {
    return $t('stores/open-until') + ' ' + $formatDate(isOpen.value, 'hh:mm', 'Europe/Amsterdam')
  }
  if (opensToday.value) {
    return $t('stores/opens-at') + ' ' + $formatDate(opensToday.value, 'hh:mm', 'Europe/Amsterdam')
  }
  if (opensTomorrow.value) {
    return $t('stores/opens-tommorrow-at') + ' ' + $formatDate(opensTomorrow.value, 'hh:mm', 'Europe/Amsterdam')
  }
  if (opensLater.value) {
    return $t('stores/opens-later-at') + ' ' + $formatDate(opensLater.value, 'dd mm hh:mm', 'Europe/Amsterdam')
  }
  return $t('stores/closed')
}
</script>
